import { render, staticRenderFns } from "./WorkDocsWorkAreaTable.vue?vue&type=template&id=5bfd40ca&"
import script from "./WorkDocsWorkAreaTable.vue?vue&type=script&lang=js&"
export * from "./WorkDocsWorkAreaTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports